import { StoryblokAsset } from '../../types';

interface Config {
  type: 'image' | 'video';
}

export const getAssetFromStoryblok = (
  asset?: StoryblokAsset,
  config: Config = { type: 'image' },
) => {
  if (!asset || !asset?.filename) {
    return {
      src: null,
      alt: null,
      title: null,
      width: 0,
      height: 0,
    };
  }

  if (config.type === 'image') {
    const widthFromUrl = Number(asset.filename.split('/')[5].split('x')[0]);
    const heightFromUrl = Number(asset.filename.split('/')[5].split('x')[1]);

    const isWidthNumber = Number.isInteger(widthFromUrl);
    const isHeightNumber = Number.isInteger(heightFromUrl);

    return {
      src: asset.filename,
      alt: asset.alt,
      title: asset.title,
      width: isWidthNumber ? widthFromUrl : 1920,
      height: isHeightNumber ? heightFromUrl : 1080,
    };
  }

  return {
    src: asset.filename,
    alt: asset.alt,
    title: asset.title,
  };
};
